<template>
  <div>
    <div class="main-content card" v-if="loader === 100">
      <div class="card-header bg-white border-bottom mb-2">
        <div class="d-flex justify-content-between align-items-center w-100">
          <h4 class="card-title mb-0 text-dark">
            <i class="fas fa-chart-pie text-primary"></i> Ocupação da Unidade
          </h4>
          <div class="ml-auto">
            <button
              class="btn btn-success btn-sm mr-2"
              @click="exportarExcel()"
              v-if="relatorio.length > 0"
            >
              <i class="fas fa-file-excel"></i> Exportar
            </button>
            <button class="btn btn-primary btn-sm" @click="buscarRelatorio()">
              <i class="fas fa-sync"></i> Atualizar
            </button>
          </div>
        </div>
      </div>

      <div class="card-body">
        <!-- Resumo Compacto -->
        <div class="row mb-3" v-if="resumo">
          <div class="col-md-3">
            <div class="summary-card">
              <div class="summary-icon bg-primary">
                <i class="fas fa-layer-group"></i>
              </div>
              <div class="summary-content">
                <strong class="text">Total</strong>
                <h3>{{ resumo.total_setores }}</h3>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="summary-card">
              <div class="summary-icon bg-success">
                <i class="fas fa-check-circle"></i>
              </div>
              <div class="summary-content">
                <strong class="text">Normais</strong>
                <h3>{{ resumo.setores_normais }}</h3>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="summary-card">
              <div class="summary-icon bg-warning">
                <i class="fas fa-exclamation-triangle"></i>
              </div>
              <div class="summary-content">
                <strong class="text">Atenção</strong>
                <h3>{{ resumo.setores_atencao }}</h3>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="summary-card">
              <div class="summary-icon bg-danger">
                <i class="fas fa-times-circle"></i>
              </div>
              <div class="summary-content">
                <strong class="text">Críticos</strong>
                <h3>{{ resumo.setores_criticos }}</h3>
              </div>
            </div>
          </div>
        </div>

        <!-- Tabela de Setores -->
        <div class="row" v-if="relatorio.length > 0">
          <div class="col-12">
            <div class="table-responsive">
              <table class="table table-hover modern-table">
                <thead>
                  <tr>
                    <th class="text-center" width="5%">#</th>
                    <th width="25%">SETOR</th>
                    <th class="text-center" width="15%">AGUARDANDO</th>
                    <th class="text-center" width="15%">CAPACIDADE</th>
                    <th class="text-center" width="15%">ALERTA</th>
                    <th class="text-center" width="20%">OCUPAÇÃO</th>
                    <th class="text-center" width="10%">STATUS</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in relatorio"
                    :key="item.setor_id"
                    :class="getRowClass(item.status)"
                  >
                    <td class="text-center">
                      <strong>{{ index + 1 }}</strong>
                    </td>
                    <td>
                      <strong class="setor-nome">{{ item.setor_nome }}</strong>
                    </td>
                    <td class="text-center">
                      <span class="badge badge-dark badge-numero">
                        {{ item.pessoas_aguardando }}
                      </span>
                    </td>
                    <td class="text-center">
                      <strong class="numero-grande">{{
                        item.capacidade_setor
                      }}</strong>
                    </td>
                    <td class="text-center">
                      <strong class="numero-grande">{{
                        item.quantidade_maxima_alerta
                      }}</strong>
                    </td>
                    <td class="text-center">
                      <div class="ocupacao-container">
                        <div class="progress" style="height: 30px">
                          <div
                            class="progress-bar"
                            :class="getProgressBarClass(item.status)"
                            role="progressbar"
                            :style="
                              'width: ' +
                              Math.min(item.percentual_ocupacao, 100) +
                              '%'
                            "
                          ></div>
                        </div>
                        <span class="percentual-text">
                          <strong
                            >{{
                              Math.min(item.percentual_ocupacao, 100)
                            }}%</strong
                          >
                        </span>
                      </div>
                    </td>
                    <td class="text-center">
                      <i
                        class="fas fa-circle status-icon"
                        :class="getStatusIconClass(item.status)"
                      ></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- Mensagem quando não há setores -->
        <div class="row" v-else>
          <div class="col-12">
            <div class="alert alert-warning text-center">
              <i class="fas fa-info-circle"></i>
              Nenhum setor com capacidade configurada encontrado.
              <br />
              <small
                >Configure a capacidade e o alerta nos setores para visualizar o
                relatório.</small
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading -->
    <div class="main-content" v-else>
      <div class="card">
        <div class="card-body text-center">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Carregando...</span>
          </div>
          <p class="mt-2">Carregando dados...</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      loader: 0,
      relatorio: [],
      resumo: null,
      autoRefreshInterval: null,
    };
  },
  mounted() {
    this.init();
    // Auto-refresh a cada 30 segundos
    this.autoRefreshInterval = setInterval(() => {
      this.buscarRelatorio(true);
    }, 30000);
  },
  beforeDestroy() {
    // Limpar interval ao sair da página
    if (this.autoRefreshInterval) {
      clearInterval(this.autoRefreshInterval);
    }
  },
  methods: {
    init() {
      this.$loading(true);
      this.buscarRelatorio();
      this.loader = 100;
    },

    buscarRelatorio(silent = false) {
      if (!silent) {
        this.$loading(true);
      }

      const api = this.$store.state.api + "relatorio-ocupacao";

      axios
        .get(api)
        .then((response) => {
          this.relatorio = response.data.data;
          this.resumo = response.data.resumo;

          if (!silent && this.relatorio.length === 0) {
            this.$message(
              "Aviso",
              "Nenhum setor com capacidade configurada encontrado.",
              "warning"
            );
          }
        })
        .catch((error) => {
          if (!silent) {
            this.$message(null, "Erro ao buscar relatório", "error");
          }
          console.error(error);
        })
        .finally(() => {
          if (!silent) {
            this.$loading(false);
          }
        });
    },

    getRowClass(status) {
      switch (status) {
        case "verde":
          return "table-success";
        case "amarelo":
          return "table-warning";
        case "vermelho":
          return "table-danger";
        default:
          return "";
      }
    },

    getProgressBarClass(status) {
      switch (status) {
        case "verde":
          return "bg-success";
        case "amarelo":
          return "bg-warning";
        case "vermelho":
          return "bg-danger";
        default:
          return "bg-primary";
      }
    },

    getStatusBadgeClass(status) {
      switch (status) {
        case "verde":
          return "badge-success";
        case "amarelo":
          return "badge-warning";
        case "vermelho":
          return "badge-danger";
        default:
          return "badge-secondary";
      }
    },

    getStatusIconClass(status) {
      switch (status) {
        case "verde":
          return "text-success";
        case "amarelo":
          return "text-warning";
        case "vermelho":
          return "text-danger";
        default:
          return "text-secondary";
      }
    },

    exportarExcel() {
      this.$loading(true);
      const api = this.$store.state.api + "relatorio-ocupacao/excel";

      axios
        .get(api, {
          responseType: "blob",
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `relatorio_ocupacao_${new Date().getTime()}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
          link.remove();

          this.$message(
            "Sucesso",
            "Relatório exportado com sucesso!",
            "success"
          );
        })
        .catch((error) => {
          this.$message(null, "Erro ao exportar relatório", "error");
          console.error(error);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
};
</script>

<style scoped>
/* Card Header */
.card-header {
  padding: 20px 25px;
}

.card-title {
  font-size: 20px;
  font-weight: 600;
}

/* Summary Cards */
.summary-card {
  display: flex;
  align-items: center;
  padding: 15px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s, box-shadow 0.2s;
}

.summary-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.summary-icon {
  width: 50px;
  height: 50px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  color: #fff;
  font-size: 20px;
}

.summary-content {
  flex: 1;
}

.summary-content small {
  display: block;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 2px;
}

.summary-content h3 {
  margin: 0;
  font-size: 28px;
  font-weight: bold;
  color: #333;
}

/* Modern Table */
.modern-table {
  border: 1px solid #dee2e6;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.modern-table thead {
  background: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
}

.modern-table thead th {
  border: none;
  color: #000;
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 0.5px;
  padding: 18px 15px;
  text-transform: uppercase;
}

.modern-table tbody tr {
  border-bottom: 1px solid #dee2e6;
  transition: all 0.2s;
}

.modern-table tbody tr:hover {
  background-color: #f8f9fa;
}

.modern-table tbody td {
  padding: 18px 15px;
  vertical-align: middle;
  border: none;
  font-size: 15px;
}

/* Textos maiores e mais legíveis */
.setor-nome {
  font-size: 16px;
  color: #212529;
}

.numero-grande {
  font-size: 16px;
  color: #495057;
}

.badge-numero {
  font-size: 18px;
  padding: 8px 16px;
}

/* Status Colors */
.table-success {
  border-left: 4px solid #28a745;
  background-color: rgba(40, 167, 69, 0.05) !important;
}

.table-warning {
  border-left: 4px solid #ffc107;
  background-color: rgba(255, 193, 7, 0.05) !important;
}

.table-danger {
  border-left: 4px solid #dc3545;
  background-color: rgba(220, 53, 69, 0.05) !important;
}

/* Progress Bar */
.ocupacao-container {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.progress {
  background-color: #e9ecef;
  border-radius: 10px;
  overflow: hidden;
  width: 100%;
}

.progress-bar {
  transition: width 0.6s ease;
  height: 100%;
}

.percentual-text {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 16px;
  font-weight: 700;
  color: #000;
  text-shadow: 0 0 3px rgba(255, 255, 255, 0.8);
  pointer-events: none;
  z-index: 10;
}

/* Badges */
.badge-lg {
  font-size: 14px;
  padding: 8px 12px;
}

.badge-dark {
  background-color: #343a40;
}

/* Icons */
.status-icon {
  font-size: 22px;
}

/* Dark Mode Support */
.dark-layout .summary-card {
  background: #283046;
}

.dark-layout .summary-content h3 {
  color: #d0d2d6;
}

.dark-layout .modern-table {
  background: #283046;
  border-color: #3b4253;
}

.dark-layout .modern-table thead {
  background: #161d31;
  border-bottom-color: #3b4253;
}

.dark-layout .modern-table thead th {
  color: #d0d2d6;
}

.dark-layout .modern-table tbody tr {
  border-bottom-color: #3b4253;
}

.dark-layout .modern-table tbody tr:hover {
  background-color: #161d31;
}

.dark-layout .setor-nome {
  color: #d0d2d6;
}

.dark-layout .numero-grande {
  color: #b4b7bd;
}

.dark-layout .table-success {
  background-color: rgba(40, 167, 69, 0.1) !important;
}

.dark-layout .table-warning {
  background-color: rgba(255, 193, 7, 0.1) !important;
}

.dark-layout .table-danger {
  background-color: rgba(220, 53, 69, 0.1) !important;
}

.dark-layout .progress {
  background-color: #3b4253;
}

.dark-layout .percentual-text {
  color: #d0d2d6;
  text-shadow: 0 0 3px rgba(0, 0, 0, 0.8);
}
</style>
